import React from "react";

import { IconButton } from "../Icon";
import { navigationService } from "./navigationService";

export const DrawerToggle = React.memo(() => {
    const handleOpen = React.useCallback(() => {
        navigationService.setForceCloseDrawer(false);
        navigationService.openDrawer();
    }, []);

    React.useEffect(() => {
        navigationService.setIsMobile(true);
        return () => {
            navigationService.closeDrawer();
            navigationService.setIsMobile(false);
        }
    }, []);

    return <IconButton mr="2" icon='menu' onPress={handleOpen} />
});
